import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMyOrders } from '@guryou/redux';

import { StateStatus } from '../core';

const useMyOrders = () => {
  const dispatch = useDispatch();

  const { data, status, version, entity } = useSelector(state => state.myOrders);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMyOrders());
    }
  }, [dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default useMyOrders;
